import ApolloClient from "apollo-client";
import { ApolloLink } from "apollo-link";
import { HttpLink } from "apollo-link-http";
import { InMemoryCache } from "apollo-cache-inmemory";

// API 1 (DEFAULT). REACT_APP_API_URL if set, else localhost in dev / prod API in
// a production build — so `npm start` always hits the local backend and prod
// builds never point at localhost.
const client1Link = new HttpLink({
  uri:
    process.env.REACT_APP_API_URL ||
    (process.env.NODE_ENV === "production"
      ? "https://capi.rizee.in/graphql"
      : "http://localhost:3008/graphql"),
});

// API 2
const client2Link = new HttpLink({
  uri: "https://devcollegeapi.rizee.in/graphql",
});

// 👇 change condition
const splitLink = ApolloLink.split(
  (operation) => operation.getContext().clientName === "client2",
  client2Link,   // if explicitly client2
  client1Link    // ✅ default now client1
);

const client = new ApolloClient({
  link: splitLink,
  cache: new InMemoryCache(),
});

export default client;